import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authService } from '@/services/authService'
import { Mail, ArrowLeft, LayoutGrid } from 'lucide-react'
import toast from 'react-hot-toast'

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState('')
    const [loading, setLoading] = useState(false)
    const [sent, setSent] = useState(false)

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setLoading(true)

        try {
            await authService.sendPasswordResetEmail(email)
            setSent(true)
            toast.success('Link de recuperação enviado!')
        } catch (error: any) {
            toast.error(error.message || 'Erro ao enviar e-mail')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] py-12 px-4 sm:px-6 lg:px-8 font-sans">
            <div className="max-w-md w-full animate-in fade-in zoom-in duration-500">
                <div className="text-center mb-10">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-3xl bg-[#1D3A6C] text-white shadow-xl shadow-primary/20 mb-6 transform hover:rotate-12 transition-transform border-4 border-[#D4AF37]/20">
                        <LayoutGrid className="w-8 h-8" />
                    </div>
                    <h2 className="text-4xl font-black text-[#1D3A6C] tracking-tight uppercase italic">SpaceRub</h2>
                    <p className="mt-2 text-gray-500 font-medium tracking-widest uppercase text-[10px]">Recuperação de Acesso</p>
                </div>

                <div className="bg-white p-10 rounded-[2.5rem] shadow-2xl shadow-gray-200/50 border border-gray-100 relative overflow-hidden">
                    {/* Decorative element */}
                    <div className="absolute top-0 right-0 w-32 h-32 bg-[#D4AF37]/5 rounded-bl-[5rem] -mr-16 -mt-16"></div>

                    {!sent ? (
                        <>
                            <h3 className="text-xl font-black text-[#1D3A6C] mb-4 uppercase tracking-tight">Esqueceu a senha?</h3>
                            <p className="text-sm text-gray-500 mb-8 font-medium leading-relaxed">
                                Digite seu e-mail abaixo e enviaremos um link para você redefinir sua senha com segurança.
                            </p>

                            <form className="space-y-6" onSubmit={handleSubmit}>
                                <div className="space-y-2">
                                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-1">E-mail</label>
                                    <div className="relative group">
                                        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-[#1D3A6C] transition-colors" />
                                        <input
                                            type="email"
                                            required
                                            className="w-full bg-gray-50 border-2 border-transparent focus:bg-white focus:border-[#1D3A6C] rounded-2xl pl-12 pr-4 py-4 text-sm transition-all outline-none font-medium"
                                            placeholder="seu@email.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="w-full bg-[#1D3A6C] hover:bg-[#D4AF37] text-white font-black py-5 rounded-2xl shadow-xl shadow-[#1D3A6C]/20 transform active:scale-[0.98] transition-all uppercase tracking-widest text-xs disabled:opacity-50"
                                >
                                    {loading ? 'Processando...' : 'Enviar Link de Recuperação'}
                                </button>
                            </form>
                        </>
                    ) : (
                        <div className="text-center py-6">
                            <div className="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
                                <Mail className="w-10 h-10" />
                            </div>
                            <h3 className="text-xl font-black text-[#1D3A6C] mb-4 uppercase">E-mail Enviado!</h3>
                            <p className="text-sm text-gray-500 mb-10 font-medium leading-relaxed">
                                Verifique sua caixa de entrada (e a pasta de spam) para o link de redefinição.
                            </p>
                            <button
                                onClick={() => setSent(false)}
                                className="text-[#1D3A6C] font-black uppercase tracking-widest text-[10px] hover:text-[#D4AF37] transition-colors"
                            >
                                Não recebeu? Tentar novamente
                            </button>
                        </div>
                    )}

                    <div className="mt-10 pt-8 border-t border-gray-50 flex justify-center">
                        <Link to="/login" className="inline-flex items-center space-x-2 text-[#1D3A6C] font-black hover:text-[#D4AF37] transition-all uppercase tracking-widest text-[10px] group">
                            <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" />
                            <span>Voltar para Login</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
